import { useTransferDashboardModel } from './transfer-dashboard-modal.model'
import type { ITransferDashboardModal } from './transfer-dashboard-modal.types'
import { TransferDashboardModalView } from './transfer-dashboard-modal.view'

export const TransferDashboardModal = (props: ITransferDashboardModal) => {
  const transferDashboardModel = useTransferDashboardModel(props)
  return <TransferDashboardModalView {...transferDashboardModel} />
}
